import { graphql, readInlineData } from 'react-relay';

import { type currencyHelpers_financialAmount$key } from './__generated__/currencyHelpers_financialAmount.graphql.ts';

const financialAmountFragment = graphql`
    fragment currencyHelpers_financialAmount on FinancialAmount @inline {
        convertedAmountList {
            amount
            currency
        }
    }
`;

export const getPriceByCurrency = (
    financialAmountRef: currencyHelpers_financialAmount$key | null | undefined,
    currency: string
): number | null => {
    if (!financialAmountRef) {
        return null;
    }
    const financialAmount = readInlineData(financialAmountFragment, financialAmountRef);
    const price = financialAmount?.convertedAmountList?.find(
        amount => amount?.currency === currency
    );
    return price?.amount ?? null;
};
